import {
  filterAttributesPath,
  findTableSettingsPath,
} from '../constants/apiEndpoints';
import { notificationType } from '../constants/globals';
import { agGridActions } from '../reducers/agGrid';
import { createNotification } from '../utils';
import { errorAction } from '../utils/actions';
import apiService from '../utils/apiService';
import { clearAttributeList } from './attribute';
import store from '../reducers/index';
import {
  prepareAggridSettings,
  prepareResponseData,
} from '../components/AgGrid/utils';
import { getModelName } from '../components/AgGrid/action-utils';
import { tableConfig } from '../constants/tables';

export const findColumnSetting = (
  table,
  messages,
  inForm,
  withoutActionColumn
) => {
  return (dispatch) => {
    dispatch(agGridActions.actionStart());
    return apiService
      .get(findTableSettingsPath(table))
      .then((response) => {
        const preparedData = prepareAggridSettings(
          response.data,
          withoutActionColumn
        );
        dispatch(
          agGridActions.fetchSettingsList(
            prepareResponseData(preparedData, table, inForm)
          )
        );
      })
      .catch((err) => {
        errorAction(err, agGridActions.actionError, dispatch, messages);
      });
  };
};

export const findRowsList = (
  table,
  attributes,
  limit,
  messages,
  gridRef,
  inForm
) => {
  return (dispatch) => {
    dispatch(agGridActions.actionStart());
    return apiService
      .post(filterAttributesPath(table, limit), attributes)
      .then((response) => {
        const data =
          response.status === 204 || response.status === 202
            ? []
            : response.data;
        dispatch(
          agGridActions.fetchRowsList(prepareResponseData(data, table, inForm))
        );
        gridRef?.current?.api?.hideOverlay();
        if (data?.length === 0) {
          if (response.status === 202) {
            createNotification(
              notificationType.info,
              messages.infoTitle,
              response.data?.message
            );
          } else {
            createNotification(
              notificationType.info,
              messages.infoTitle,
              messages.notFoundRecords
            );
          }
          gridRef?.current?.api?.showNoRowsOverlay();
        }
      })
      .catch((err) => {
        errorAction(err, agGridActions.actionError, dispatch, messages);
      });
  };
};

export const clearRowsList = (type) => {
  return (dispatch) => {
    dispatch(agGridActions.clearRowsList(type));
  };
};

export const clearSettingsList = (type) => {
  return (dispatch) => {
    dispatch(agGridActions.clearSettingsList(type));
  };
};

export const clearAggridReducer = () => {
  store.dispatch(clearRowsList());
  store.dispatch(clearSettingsList());
  store.dispatch(clearAttributeList());
};

export const clearGridData = (location) => {
  return () => {
    if (window?.location?.pathname !== location) {
      clearAggridReducer();
    }
  };
};

//akcija za brisanje rekorda iz aggrid-a generalno, kao i za aktivaciju/deaktivaciju
//treba da hendla sve akcije kod kojih se kao parametar prosleđuje id
export const executeActionWithDataId = ({
  id,
  tableName,
  action,
  operation,
  messages,
  deleteToModal,
  additionalProps,
}) => {
  return async (dispatch) => {
    dispatch(agGridActions.actionStart());
    try {
      await import(`./${tableName}`).then((originalAction) => {
        const type = Object.values(tableConfig)?.find(
          (t) => t.singularName === tableName
        )?.name;
        dispatch(
          originalAction?.[action]?.({
            id,
            messages,
            callback: (responseData) => {
              dispatch(
                agGridActions[`${operation}Row`]?.({
                  data: responseData,
                  inForm: deleteToModal ? type : null,
                })
              );
              deleteToModal &&
                dispatch(
                  agGridActions[`${operation}RowForModal`]({
                    type: type,
                    id: responseData?.id,
                    additionalProps,
                  })
                );
            },
            additionalProps,
          })
        );
      });
    } catch (err) {
      errorAction(err, agGridActions.actionError, dispatch, messages);
    }
  };
};

export const findDataById = ({ id, tableName, messages, inForm }) => {
  const modelName = getModelName(tableName);
  return async (dispatch) => {
    dispatch(agGridActions.actionStart());
    try {
      await import(`./${tableName}`).then((originalAction) => {
        dispatch(
          originalAction?.[`fetch${modelName}ById`]?.(id, messages, inForm)
        );
      });
    } catch (err) {
      errorAction(err, agGridActions.actionError, dispatch, messages);
    }
  };
};

export const clearData = (tableName, inForm) => {
  const modelName = getModelName(tableName);
  return async (dispatch) => {
    await import(`./${tableName}`).then((originalAction) => {
      dispatch(originalAction?.[`clear${modelName}`]?.(inForm));
    });
  };
};

export const saveData = ({
  data,
  tableName,
  messages,
  callback,
  additionalParams,
  action,
  operation,
  addToModalSignal,
}) => {
  return async (dispatch) => {
    dispatch(agGridActions.actionStart());
    try {
      await import(`./${tableName}`).then((originalAction) => {
        const type = Object.values(tableConfig)?.find(
          (t) => t.singularName === tableName
        )?.name;
        dispatch(
          originalAction?.[action]?.(
            data,
            (responseData) => {
              !addToModalSignal &&
                dispatch(agGridActions[`${operation}Row`]?.(responseData));
              addToModalSignal &&
                dispatch(
                  agGridActions[`${operation}RowForModal`]({
                    type,
                    data: responseData,
                  })
                );
              callback?.();
            },
            messages,
            additionalParams,
            addToModalSignal
          )
        );
      });
    } catch (err) {
      errorAction(err, agGridActions.actionError, dispatch, messages);
    }
  };
};
